// takes a float, and turns it into a number/float we'd use for percentages
// it rounds to the nearest ten-thousandth
// ex: num = .00019 (which is .019%) so this func will round the number and set it to .02
export function toPercentageNumber(num: number): number {
  return (Math.round(num * 10000) * 100) / 10000;
}

// turns a number into a percent string
// ex: .00019 -> "0.02%"
// ex: .1 => "1%"
export function toPercentage(num: number): string {
  return toPercentageNumber(num).toString() + '%';
}
